export default __webpack_public_path__ + "static/media/demo.3e46865a.svg";